import { useState } from "react";
import Input from "../common/Input";
import Button from "../common/Button";
import { createSlogan } from "../../../services/sloganServices";
import { toast } from "react-hot-toast";

const SloganForm = () => {
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!text.trim()) {
      toast.error("Slogan text is required");
      return;
    }

    try {
      setLoading(true);
      await createSlogan({ text });
      toast.success("Slogan created successfully");
      setText("");
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md p-6 bg-[#F5F0FF] rounded-lg space-y-4 font-sans">
      <Input
        label="Slogan"
        value={text}
        onChange={setText}
        placeholder="Proud member of SAP"
        required
      />

      <div className="pt-2 space-y-2">
        <Button onClick={handleSubmit} className="w-full" disabled={loading}>
          {loading ? "Submitting..." : "Confirm & Add Slogan"}
        </Button>
        <Button variant="text" className="w-full">
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default SloganForm;
